import type { PlatformTypeName } from "@multi-chat/shared";
import {
  isPlatformEntitlementEnabled,
  type OrganizationPlatformFlags,
} from "../organizations/use-organization-platform-flags.js";

export const PLATFORM_NOT_ENABLED_CODE = "PLATFORM_NOT_ENABLED";

/** A send or upload for this conversation was rejected because its platform is turned off. */
export interface PlatformEntitlementRejection {
  organizationId: number;
  conversationId: number;
  platform: PlatformTypeName;
  /** Flag-load version current when the rejection arrived. */
  flagsVersion: number;
}

export interface ComposerEntitlementInput {
  flags: OrganizationPlatformFlags | null;
  flagsVersion: number;
  organizationId: number;
  conversationId: number;
  platform: PlatformTypeName;
  rejection: PlatformEntitlementRejection | null;
}

export function isPlatformNotEnabledCode(code: string | null | undefined): boolean {
  return code === PLATFORM_NOT_ENABLED_CODE;
}

/**
 * Flags known false block the composer. A rejection blocks only the conversation it
 * came from, until a flag load newer than the rejection reports the platform enabled.
 * Unknown flags (loading or failed) never block on their own.
 */
export function isComposerBlockedByPlatformEntitlement(input: ComposerEntitlementInput): boolean {
  const enabled = isPlatformEntitlementEnabled(input.flags, input.platform);
  if (enabled === false) return true;

  const { rejection } = input;
  if (rejection == null) return false;
  if (
    rejection.organizationId !== input.organizationId ||
    rejection.conversationId !== input.conversationId ||
    rejection.platform !== input.platform
  ) {
    return false;
  }
  if (enabled === true && input.flagsVersion > rejection.flagsVersion) return false;
  return true;
}
